import React, { useEffect, useState } from 'react';
import KanbanContainerImportacao from './KanbanContainerImportacao';
import KanbanProvider from './KanbanProvider';
import { useAppContext } from 'Main';
import { getIdEmpresa, getIdUsuario, getOperacaoLocal } from 'helpers/auth';
import api from 'helpers/api';
import Flex from 'components/common/Flex';
import { Spinner } from 'react-bootstrap';

const Kanban = ({operacao, filterPeriodo}) => {
  const {
    config: { isFluid, isNavbarVerticalCollapsed },
    setConfig
  } = useAppContext();
  const [data2, setData] = useState([]);
  const [kanbanIsFluid] = useState(isFluid);
  const [kanbanIsNavbarVerticalCollapsed] = useState(isNavbarVerticalCollapsed);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (getIdUsuario() === null) {
      window.location.href = '/';
    }
    setConfig('isFluid', true);
    setConfig('isNavbarVerticalCollapsed', true);

    const getProcess = async () => {
      setIsLoading(true);

      const result = await api.post(
        '/api/processesKanbam/', {
        companyId: getIdEmpresa(),
        operacao: operacao,
        filter: filterPeriodo
      }
      );
      const data = result.data.data;

      setData(data);
      setIsLoading(false);
    };
    if (getIdEmpresa() > 0) {
      getProcess();
    }

    return () => {
      setConfig('isFluid', kanbanIsFluid);
      setConfig('isNavbarVerticalCollapsed', kanbanIsNavbarVerticalCollapsed);
    };
  }, []);

  return (
    <>
      {isLoading ? (
        <>
          <Flex justifyContent="center">
            <div className="p-2">
              <Spinner />
              <span> Aguarde carregando ...</span>
            </div>
          </Flex>
        </>
      ) : (
        <>
          {' '}
          <KanbanProvider>
            <KanbanContainerImportacao dados={data2} operacao={operacao} />
          </KanbanProvider>
        </>
      )}
    </>
  );
};

export default Kanban;
